import { Injectable, inject, isDevMode } from '@angular/core';
import { GlobalService } from '../global/global.service';

const LOCAL_SSR_PROXY_URL = 'http://localhost:2385';

const DOCKER_PUB_SERVICE_URL = 'http://pub-service:7070/';

const DOCKER_API_V1_URL = `${DOCKER_PUB_SERVICE_URL}api/v1`;

const DOCKER_API_V2_URL = `${DOCKER_PUB_SERVICE_URL}api/v2`;

const DOCKER_API_V3_URL = 'http://backend:23050';

const DOCKER_PUBLIC_DATA_SERVICE_URL = `${DOCKER_PUB_SERVICE_URL}public/data/`;

const DOCKER_ACCESS_CONTROL_URL = 'http://access-control:20815';

const DOCKER_LANGUAGE_URL = `${DOCKER_API_V2_URL}/languages/`;

const DOCKER_GEO_API_URL = 'http://gateway/api/v1/utilities/geo';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private globalService: GlobalService = inject(GlobalService);

  NODE_ENV = 'localhost'; // import.meta.env.NODE_ENV;

  SSR = this.globalService.isServer();

  get PUBLIC_PUBLICATION_PATH() {
    return this.getPublicationUrl();
  }

  get PUBLIC_PUBLICATION_PATH_PUB() {
    return this.getPublicationPublicUrl();
  } // SERVER ? 'http://pub-service:7070/' : '/services/pub/';
  get PUBLIC_DATA_PATH() {
    return this.getPublicDataUrl();
  } // SERVER ? 'http://pub-service:7070/public/data/' : '/services/publicdata/';
  get ACCESS_CONTROL_PATH() {
    return this.getAccessControlUrl();
  } //SERVER ? 'http://access-control:20815' : '/services/access-control';
  get LANGUAGE_PATH() {
    return this.getLanguageUrl();
  } //SERVER ? 'http://pub-service:7070/api/v2/languages/' : '/api/v2/languages/';
  get APIV3() {
    return this.getApiV3Url();
  } //SERVER ? 'http://backend:23050' : '/api/v3';
  get APIV2() {
    return this.getApiV2Url();
  } //SERVER ? 'http://backend:23050' : '/api/v3';
  get APIV1() {
    return this.getApiV1Url();
  }
  get NEW_GEO_API_PATH() {
    return this.getNewGeoAPiUrl();
  } // SERVER ? 'http://gateway/api/v1/utilities/geo' : '/api/v1/utilities/geo';

  get ContentPublic() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/content`;
  }
  get GaCodeApi() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/gacode`;
  }
  get MetricApi() {
    return `${this.PUBLIC_PUBLICATION_PATH}pub/api/v1/record/metrics/`;
  }
  get StripeKeyApi() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/stripekey`;
  }
  get OctobatKeyApi() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/octobatkey`;
  }
  get CONTENT_API() {
    return `${this.PUBLIC_PUBLICATION_PATH_PUB}api/v1/content`;
  }
  get FILES_API() {
    return `${this.PUBLIC_PUBLICATION_PATH}api/v2/files`;
  }
  get TAGS_API() {
    return `${this.PUBLIC_PUBLICATION_PATH_PUB}api/v1/tags`;
  }
  get BLOG_API() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/blog`;
  }
  // get APIV2() { return this.SERVER ? 'http://pub-service:7070/api/v2' : '/api/v2';
  // get APIV1() { return this.SERVER ? `${PUBLIC_PUBLICATION_PATH_PUB}api/v1` : '/services/pub/api/v1';

  get GEO_API_PATH() {
    return `${this.PUBLIC_PUBLICATION_PATH_PUB}api/v1/geo`;
  }
  get GEO_PUBLIC_API_PATH() {
    return `${this.PUBLIC_PUBLICATION_PATH}public/geo`;
  }

  getPublicationUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_PUB_SERVICE_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/services/`;
    }
    return '/services/';
  };

  getPublicationPublicUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_PUB_SERVICE_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/services/pub/`;
    }
    return '/services/pub/';
  };

  getPublicDataUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_PUBLIC_DATA_SERVICE_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/services/publicdata/`;
    }
    return '/services/publicdata/';
  };

  getApiV1Url = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_API_V1_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/services/pub/api/v1`;
    }
    return '/services/pub/api/v1';
  };

  getApiV2Url = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_API_V2_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/api/v2`;
    }
    return '/api/v2';
  };

  getApiV3Url = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_API_V3_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/api/v3`;
    }
    return '/api/v3';
  };

  getAccessControlUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_ACCESS_CONTROL_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/services/access-control`;
    }
    return '/services/access-control';
  };

  getLanguageUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_LANGUAGE_URL;
      }
      return `${LOCAL_SSR_PROXY_URL}/api/v2/languages/`;
    }
    return '/api/v2/languages/';
  };

  getNewGeoAPiUrl = () => {
    if (this.SSR) {
      if (!isDevMode()) {
        return DOCKER_GEO_API_URL;
      }
      return LOCAL_SSR_PROXY_URL;
    }
    return '/api/v1/utilities/geo';
  };
}
